var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Toolbar'),_c('v-card',{attrs:{"min-height":"calc(75vh)"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }